import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// Default branch title-cases the kebab enum value so an unmapped icon still renders something sensible.
export function mapViewLocationTypeLabel(
  icon: MapViewLocationIcon,
  t: typeof Localization.translator = Localization.translator,
): string {
  switch (icon) {
    case MapViewLocationIcon.Project:
      return t.project
    case MapViewLocationIcon.Building:
      return t.building
    case MapViewLocationIcon.Level:
      return t.level
    case MapViewLocationIcon.Zone:
      return t.zone
    case MapViewLocationIcon.Area:
      return t.area
    case MapViewLocationIcon.Gate:
      return t.gate
    case MapViewLocationIcon.Route:
      return t.route
    case MapViewLocationIcon.Logistics:
      return t.logistics
    case MapViewLocationIcon.Staging:
      return t.staging
    case MapViewLocationIcon.Trailer:
      return t.trailer
    case MapViewLocationIcon.Walkway:
      return t.walkway
    case MapViewLocationIcon.Equipment:
      return t.equipment
    default:
      return icon
        .split('-')
        .map(w => (w.length === 0 ? w : w[0].toUpperCase() + w.slice(1)))
        .join(' ')
  }
}
